var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "d-flex w-100" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column", attrs: { id: "cancellations" } },
      [
        _vm._m(0),
        _c("div", { staticClass: "flex-grow-1 overflow-hidden d-flex" }, [
          _c(
            "div",
            { staticClass: "card card-no-margin" },
            [
              _c("h4", [
                _vm._v(
                  _vm._s(_vm.cancellations_total) + " demandes de résiliation"
                )
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-end align-items-start mb-3",
                  staticStyle: { "margin-top": "-60px" }
                },
                [
                  _c("m-form-select", {
                    attrs: {
                      width: 300,
                      label: "Filter par statut",
                      "label-position": "top",
                      name: _vm.$Utils.randomstring("filterStatus"),
                      items: _vm.$store.state.items_cr_statuses
                    },
                    on: { input: _vm.loadCancellations },
                    model: {
                      value: _vm.filterStatus,
                      callback: function($$v) {
                        _vm.filterStatus = $$v
                      },
                      expression: "filterStatus"
                    }
                  }),
                  _c("m-form-text", {
                    staticClass: "ml-3",
                    attrs: {
                      label: "Rechercher",
                      "label-position": "top",
                      name: "search",
                      autocomplete: ""
                    },
                    on: { input: _vm.loadCancellations },
                    model: {
                      value: _vm.filterText,
                      callback: function($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText"
                    }
                  })
                ],
                1
              ),
              _c("m-list", {
                ref: "cancellationslist",
                attrs: {
                  dynamic: true,
                  items: _vm.cancellations,
                  "item-value": "or_id",
                  "item-height": 30,
                  limit: _vm.cancellations_limit,
                  skip: _vm.cancellations_skip,
                  total: _vm.cancellations_total,
                  bgstrip: true
                },
                on: {
                  changerange: _vm.cancellationsChangeRange,
                  itemclick: _vm.editCancellation
                },
                scopedSlots: _vm._u([
                  {
                    key: "ths",
                    fn: function(ref) {
                      return [
                        _c("th", { staticStyle: { width: "40px" } }),
                        _c("th", { staticStyle: { width: "40px" } }, [
                          _vm._v(" # ")
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Contact")
                          ])
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Bénéficiaire")
                          ])
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Statut")
                          ])
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Mis à jour le")
                          ])
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Créée le")
                          ])
                        ])
                      ]
                    }
                  },
                  {
                    key: "tds",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "td",
                          { staticStyle: { width: "40px" } },
                          [
                            _c("icon", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.mustCallBack(
                                    item.cr_reason,
                                    item.cr_status
                                  ),
                                  expression:
                                    "mustCallBack(item.cr_reason, item.cr_status)"
                                }
                              ],
                              attrs: {
                                name: "phone-alt",
                                scale: "1.2",
                                color: "green"
                              }
                            }),
                            _c("icon", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isDead(item.cr_reason),
                                  expression: "isDead(item.cr_reason)"
                                }
                              ],
                              attrs: {
                                name: "dizzy",
                                scale: "1.2",
                                color: "green"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            style:
                              "width: 40px; background-color: " +
                              _vm.isLate(item.cr_status_date) +
                              ";"
                          },
                          [
                            _c("span", { staticClass: "position-relative" }, [
                              _vm._v(" " + _vm._s(item.cr_id) + " "),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isNew(item.cr_status),
                                    expression: "isNew(item.cr_status)"
                                  }
                                ],
                                staticClass: "label-new"
                              })
                            ])
                          ]
                        ),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(item.co_id.co_invoice_firstname) +
                              " " +
                              _vm._s(item.co_id.co_invoice_name) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.en_id
                                  ? item.en_id.en_fullname
                                  : "[donnée non disponible]"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getCancellationStatus(item.cr_status)
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$moment(item.cr_status_date)
                                  .format("DD/MM/YYYY HH[H]mm")
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$moment(item.createdAt)
                                  .format("DD/MM/YYYY HH[H]mm")
                              ) +
                              " "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("cancellation-win-edit", {
                attrs: { row_cr_p: _vm.itemSelected },
                on: { reload: _vm.loadCancellations },
                model: {
                  value: _vm.dialog,
                  callback: function($$v) {
                    _vm.dialog = $$v
                  },
                  expression: "dialog"
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "row header-emotivi mb-3 justify-content-around align-items-end"
      },
      [
        _c("div", { staticClass: "col" }, [
          _c("h1", [_vm._v("Demandes de résiliations")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }